<template>
  <div class="payment-confirmation-content">
    <QCardSection>
      <QList>
        <QItem dense>
          <IconLabel
            heavy
            no-padding
            :label="$tc('ETAB.PAGES.SUBSCRIPTION.@OFFER_CHOSEN', selectedOffer.getMonthDuration())"
            icon="icon-extra-check"
          />
        </QItem>
        <QItem>
          <QItemLabel>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="$t('ETAB.PAGES.SUBSCRIPTION.@OFFER_PRICE', { amount: selectedOffer.getAmountHt() })" />
          </QItemLabel>
        </QItem>

        <QSeparator spaced inset />

        <QItem dense>
          <IconLabel heavy no-padding :label="$t('ETAB.PAGES.SUBSCRIPTION.@START_DATE')" icon="icon-extra-date" />
        </QItem>
        <QItem>
          <QItemLabel>
            <p>{{ displayDuration }}</p>
          </QItemLabel>
        </QItem>

        <QSeparator spaced inset />

        <QItem>
          <IconLabel heavy no-padding :label="$t('ETAB.PAGES.SUBSCRIPTION.@PAYMENT_METHOD')" icon="icon-extra-bank" />
        </QItem>
        <QItem>
          <QItemLabel>
            <p>{{ $t("ETAB.PAGES.SUBSCRIPTION.@GLC") }}</p>
          </QItemLabel>
        </QItem>

        <QSeparator spaced inset />
      </QList>
    </QCardSection>

    <QCardSection class="text-center">
      <QBtn
        :label="$t('ETAB.PAGES.SUBSCRIPTION.LABELS.@PAY')"
        no-caps
        color="secondary"
        class="btn-navigation btn-large q-mb-md"
        @click="$emit('paymentSubscriptionAction')"
      />
      <br />
      <QBtn v-close-popup no-caps class="text-underline btn-navigation btn-large" flat :label="$t('ETAB.PAGES.SUBSCRIPTION.LABELS.@CANCEL')" />
    </QCardSection>
  </div>
</template>

<script>
  import { SubscriptionOffersModel } from "@core/models";

  export default {
    props: {
      selectedOffer: {
        type: Object,
        default: () => new SubscriptionOffersModel(),
      },
      formattedDateNow: {
        type: String,
        default: "",
      },
    },
    emits: ["paymentSubscriptionAction"],
    computed: {
      displayOfferPriceAndDuration() {
        return `${this.$tc("ETAB.PAGES.SUBSCRIPTION.@OFFER_MONTH_DURATION_MODAL", this.selectedOffer.getMonthDuration())} ${this.$t(
          "ETAB.PAGES.SUBSCRIPTION.@OFFER_PRICE",
          { amount: this.selectedOffer.getAmountHt() },
        )}`;
      },
      displayDuration() {
        if (this.selectedOffer.getMonthDuration()) {
          return this.$t("ETAB.PAGES.SUBSCRIPTION.@START_DATE_WITH_ENGAGEMENT", {
            startDate: this.formattedDateNow,
            endDate: this.selectedOffer.getFormattedEndDate(),
          });
        }
        return this.$t("ETAB.PAGES.SUBSCRIPTION.@START_DATE_WITHOUT_ENGAGEMENT", {
          startDate: this.formattedDateNow,
        });
      },
    },
  };
</script>
<style lang="scss">
  .payment-confirmation-content {
    .payment-confirmation-labels {
      display: flex;
      font-weight: bold;
      > p {
        padding-top: 5px;
      }
    }
  }
</style>
